import { DetailsSectionFlowContent } from 'app/main/components/page-layouts';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import ActivitiesEvents from './ActivitiesEvents';

import ActivitiesDetailsSectionInfo from './details/sections/ActivitiesDetailsSectionInfo';
import ActivitiesDetailsSectionSecondaryInfo from './details/sections/ActivitiesDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<ActivitiesDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<ActivitiesDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="acti_descriptionhtml"
				value={props.model.acti_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_FLOW_SECTION" />
			<DetailsSectionFlowContent module="activities" {...props} />
		</>
	),
	events: ActivitiesEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
